import gql from 'graphql-tag'

export default gql`mutation go($data: user_rolesInput!){
  upsert_user_roles(data: $data){
    user_role_id
    description
  }
}`